import React, { Component } from 'react';
import FooterLarge from '../footer/FooterLarge';
import arrow from '../../assets/images/icons/arrow-white-right.svg';
import play from '../../assets/images/icons/play-icn.svg';
import { api_url, headers } from '../../common/config';
import { Link } from 'react-router-dom';
import Tags from './Tags';
import ReactPlayer from 'react-player';
import { withTranslation } from 'react-i18next';

class Video extends Component {
    constructor(props) {
        super(props);

        this.state = {
            video: [],
            image: null,
            imageLink: null,
            timestamp: null,
            date: [''],
            tag: [''],
        };
    }

    async componentDidMount() {
        if (this.props.match.params.page === 'blog') {
            await fetch(
                `${api_url}/autism/items/resources_page_videos/${this.props.match.params.id}`,
                {
                    method: 'GET',
                    // headers: headers,
                }
            )
                .then((res) => res.json())
                .then((res) => {
                    console.log('Response', res);
                    this.setState({
                        video: res.data,
                        image: res.data.image,
                        timestamp: res.data.created_on,
                        tag: res.data.tags,
                    });
                });
        } else if (this.props.match.params.page === 'media') {
            await fetch(
                `${api_url}/autism/items/news_page_videos/${this.props.match.params.id}`,
                {
                    method: 'GET',
                    // headers: headers,
                }
            )
                .then((res) => res.json())
                .then((res) => {
                    console.log('Response', res);
                    this.setState({
                        video: res.data,
                        image: res.data.image,
                        timestamp: res.data.created_on,
                        tag: res.data.tags,
                    });
                });
        }
        // .then(() =>
        //     fetch(`${api_url}/autism/files/${this.state.image}`, {
        //         method: 'GET',
        //         headers: headers,
        //     })
        //         .then((res) => res.json())
        //         .then((res) => {
        //             console.log('image', res);
        //             this.setState({
        //                 imageLink: res,
        //             });
        //         })
        // );

        this.getImage();
        this.getDate();
    }

    getImage = async () => {
        if (this.state.image !== null) {
            await fetch(`${api_url}/autism/files/${this.state.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    console.log('image', res);
                    this.setState({
                        imageLink: res.data.data.full_url,
                    });
                });
        } else {
            console.log('Waiting');
        }
    };

    getDate = async () => {
        if (this.state.timestamp !== null) {
            await this.setState({
                date: this.state.timestamp.split(' '),
            });
        } else {
            console.log('Waiting');
        }
    };

    getTags = () => {
        if (this.state.video.tags !== undefined) {
            return this.state.tag.map((tag) => <Tags tag={tag} />);
        } else {
            return '';
        }
    };

    render() {
        const { t, i18n } = this.props;
        return (
            <>
                <div className='reader-vid-container'>
                    <div className='header'></div>
                    <div className='body-container'>
                        <div className={`reader-back ${i18n.language === 'en' ? 'pl-5' : ''}`}>
                            <Link
                                to={`/${this.props.match.params.page}`}
                                className='d-flex back-link'
                            >
                                <img src={arrow} alt='arrow' className={`${i18n.language === 'en' ? 'flip mr-1' : ''}`} />
                                <h6>{t('back')}</h6>
                            </Link>
                        </div>
                        <div className='body'>
                            <div className='body-header'>
                                <h6>{this.state.date[0]}</h6>
                                <h1>{this.state.video.title}</h1>
                                <div className='tags'>
                                    <h5>{this.getTags()}</h5>
                                </div>
                            </div>
                            <div className='body-content'>
                                <div className='video'>
                                    <ReactPlayer
                                        width='100%'
                                        height='100%'
                                        url={`${this.state.video.video_link}`}
                                    />
                                </div>
                                <div className='text'>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: this.state.video.body,
                                        }}
                                    ></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterLarge large />
            </>
        );
    }
}

export default withTranslation()(Video);
